module.exports = __webpack_public_path__ + "img/celtic3.cfadedf2.jpg";